import { render, staticRenderFns } from "./unmatched-clients-list.vue?vue&type=template&id=1ae3f485&scoped=true"
import script from "./unmatched-clients-list.vue?vue&type=script&lang=js"
export * from "./unmatched-clients-list.vue?vue&type=script&lang=js"
import style0 from "./unmatched-clients-list.vue?vue&type=style&index=0&id=1ae3f485&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae3f485",
  null
  
)

export default component.exports